import 'dayjs/locale/kk'

const kk = {
  calendar: {
    sameDay: '[Бүгін сағат] LT',
    nextDay: '[Ертең сағат] LT',
    nextWeek: 'dddd [сағат] LT',
    lastDay: '[Кеше сағат] LT',
    lastWeek: '[Өткен аптаның] dddd [сағат] LT',
    sameElse: 'L'
  }
}

export default kk
